import { useAppSelector } from 'store/hooks';

const useAuth = () => {
	const isAuth = useAppSelector((state) => Boolean(state.subscriber.details));

	return { isAuth };
};

export default useAuth;
